import create from '@qcolor/create';
import { components } from '@qcolor/components';

const preset = create({
  components,
});

export default preset;